import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

export const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routes').then(m => m.AuthRoutes),
    },
    {
        path: 'proctor',
        loadChildren: () => import('./proctor/proctor.routes').then(m => m.ProctorRoutes),
        canActivate: [AuthGuard],
    },
    {
        path: 'public',
        loadChildren: () => import('./public/public.routes').then(m => m.PublicRoutes),
    },
    {
        path: 'quiz',
        loadChildren: () => import('./quiz/quiz.routes').then(m => m.QuizRoutes),
        canActivate: [AuthGuard],
    },
    { path: 'login', redirectTo: 'auth/login', pathMatch: 'full' },
    { path: '', redirectTo: 'auth', pathMatch: 'full' },
    { path: '**', redirectTo: 'pages' },
];
